import { createReducer, on } from '@ngrx/store';
import { setFundChartSecuritylistSecurityId } from './security-list-security-id.actions';
export const securitylistSecurityId = createReducer('', on(setFundChartSecuritylistSecurityId, (state, { securitylistSecurityId: newSecuritylistSecurityId }) => newSecuritylistSecurityId));
